// extracted by mini-css-extract-plugin
module.exports = {"container":"MiscInfo_container__s9ssh","row":"MiscInfo_row__9KiXf","value":"MiscInfo_value__4jS53","icon":"MiscInfo_icon__2uXUg"};